const productCDDorCDI = {
  data() {
    return {
      helpText: 'Offer.Product.help'
    }
  },
  methods: {
    labelPriceCDDorCDI(product){
      return !!product["isProductCDI"] ? `${product.contractType}CDI` : `${product.contractType}`;
    },
    isProductCDI(product){
      return !!product["isProductCDI"];
    },
    helpTextCDDorCDI(product){
      return !!product["isProductCDI"] ? "Offer.Product.helpCDI" : "Offer.Product.help";
    },
    openModalHelp(product){
      this.helpText = this.helpTextCDDorCDI(product);
      this.showVariable = true
    }
  }
}

export default productCDDorCDI;



// WEBPACK FOOTER //
// ./src/mixins/productCDDorCDI.js